module.exports = __webpack_public_path__ + "static/media/AYSE ALMUSTAFA.cfee2c24.png";